import React, { useState } from 'react';
import { mergeRestaurantExempleProps } from '../../utils/restaurantExempleDefaults';
import { RestaurantBlock, useRestaurantContext } from './RestaurantExempleBlocks';
import './RestaurantExemple.css';

export default function RestaurantSectionBlock({
  props: rawProps,
  site,
  slug,
  interactive = true,
  commandeUrl,
}) {
  const variant = rawProps?.variant || 'hero';
  const p = mergeRestaurantExempleProps(rawProps);
  const [navOpen, setNavOpen] = useState(false);
  const closeNav = () => setNavOpen(false);
  const baseCtx = useRestaurantContext(p, { site, slug, interactive, commandeUrl });
  const ctx = {
    ...baseCtx,
    navOpen,
    setNavOpen,
    closeNav,
    site,
  };

  return (
    <div className="restaurant-exemple restaurant-exemple-fragment">
      <RestaurantBlock variant={variant} p={p} ctx={ctx} />
    </div>
  );
}
